import React from 'react';
import { useSelector } from 'react-redux';
import { Container } from 'reactstrap';
import 'moment/locale/fr';
import DateTimePicker from './date_time_picker';
import LabelDropdown from './label_dropdown';
import LastUpdateDate from './last_update_date';
import { PrivateComponent } from '../permissions';
import { getFeatureByPath } from '../routing/services';
import { getFeatures } from '../../redux/app/appActions';
import { INavBar } from './types';
import URLS from '../routing/urls';
import TopBar from '../overview/top_bar';
import './NavBar.scss';

export const NavBar: React.FC<INavBar> = ({ elements }) => {
  const features = useSelector(getFeatures);
  const { pathname } = window.location;
  const elementList = {
    lastUpdate: () => (
      <PrivateComponent
        key="navbar-lastUpdate"
        authorizationStrategy={() =>
          getFeatureByPath(features, 'overview.optimize')
        }
      >
        <LastUpdateDate />
      </PrivateComponent>
    ),
    date: () => <DateTimePicker key="navbar-date" />,
    funnel: () => <LabelDropdown key="navbar-funnel" />
  };

  return (
    <div
      className={`vrr-navbar ${!!elements?.length ? 'with-list' : ''} navbar-transparent`}
    >
      <Container fluid className="vrr-navbar-container">
        {pathname === URLS.OVERVIEW_ALL ||
        pathname === URLS.OVERVIEW_YOUTUBE ? (
          <TopBar />
        ) : (
          <div />
        )}
        <div className="vrr-navbar-wrapper">
          {Object.keys(elementList).map((element, index) => {
            if (elements?.includes(element)) {
              return (
                <div key={`element-${index.toString()}`}>
                  {(elementList as any)[element]()}
                </div>
              );
            }
          })}
        </div>
      </Container>
    </div>
  );
};

export default NavBar;
